import { render, staticRenderFns } from "./TransplantMobileItem.vue?vue&type=template&id=60f1bdc2"
import script from "./TransplantMobileItem.vue?vue&type=script&lang=js"
export * from "./TransplantMobileItem.vue?vue&type=script&lang=js"
import style0 from "./TransplantMobileItem.vue?vue&type=style&index=0&id=60f1bdc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports